import React, { useEffect, useState } from 'react'
import './AdminLeagueList.css'
import { NavLink } from 'react-router-dom'
import AdminNavigation from './AdminNavigation'
//import RostersDatabaseTable from '../../shared/components/RostersDatabaseTable'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import Modal from '../../shared/components/UIElements/Modal'
import { useHttpClient } from '../../shared/hooks/http-hook'

const AdminArchivedLeagueList = () => {
	const { sendRequest, clearError } = useHttpClient()
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [leagueId, setLeagueId] = useState('')
	//const [numberOfTeams, setNumberOfTeams] = useState()
	const [showConfirmMoveToCurrentModal, setShowConfirmMoveToCurrentModal] =
		useState(false)
	const [leagueToCurrent, setLeagueToCurrent] = useState()
	const [loadedArchivedLeagues, setLoadedArchivedLeagues] = useState()

	//No dependencies means this will only render once, which is what we want
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/leagues/archive'
				)
				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedArchivedLeagues(responseData.archivedLeagues)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setLeagueToCurrent(false)
			setIsLoading(false)
		}
		sendRequest()
	}, [leagueToCurrent])

	const errorHandler = () => {
		setError(null)
	}

	//******************************************************** */
	//
	//     Archive warning
	//
	//******************************************************** */
	const showMoveToCurrentHandler = (e) => {
		const value = e.target.id
		console.log(loadedArchivedLeagues[value]._id)
		setLeagueId(loadedArchivedLeagues[value]._id)
		setShowConfirmMoveToCurrentModal(true)
	}

	const cancelMoveToCurrentHandler = () => {
		setShowConfirmMoveToCurrentModal(false)
	}

	const confirmMoveToCurrentHandler = async () => {
		setShowConfirmMoveToCurrentModal(false)
		try {
			await sendRequest(
				`${process.env.REACT_APP_BACKEND_URL}/admin/${leagueId}/archiveCurrentToggleLeague`,
				'PATCH'
			)
		} catch (err) {}
		setLeagueToCurrent(true)
	}

	return (
		<React.Fragment>
			<ErrorModal error={error} onClear={errorHandler} />
			{isLoading && (
				<div className='center'>
					<LoadingSpinner />
				</div>
			)}
			<Modal
				show={showConfirmMoveToCurrentModal}
				onCancel={cancelMoveToCurrentHandler}
				header='Are you sure?'
				footerClass='place-item__modal-actions'
				footer={
					<React.Fragment>
						<p className='modalText'>
							Are you sure you wish to move this league to Current status?
						</p>
						<br></br>
						<button
							className='cancelDeleteButtons buttonButton'
							inverse
							style={{ float: 'right' }}
							onClick={cancelMoveToCurrentHandler}
						>
							CANCEL
						</button>
						<button
							className='cancelDeleteButtons buttonButton'
							danger
							onClick={confirmMoveToCurrentHandler}
						>
							MOVE TO CURRENT
						</button>
					</React.Fragment>
				}
			></Modal>
			{!isLoading && !loadedArchivedLeagues && (
				<div className='AdminLeagues'>
					<AdminNavigation />
					<h1>No Archived Tournaments!</h1>
				</div>
			)}
			{!isLoading && loadedArchivedLeagues && (
				<div className='AdminLeagues'>
					<AdminNavigation />
					<h1>Archived Tournaments</h1>
					<table id='archived'>
						<thead>
							<tr>
								<th>Tournament Name</th>
								<th>Year</th>
								<th>Divisions</th>
								<th></th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{loadedArchivedLeagues.map((league, key) => {
								return (
									<tr key={key}>
										<td>{league.leagueName}</td>
										<td>{league.year}</td>
										<td>{league.numberOfTeams}</td>
										<td>
											<NavLink
												className='navlinks'
												to={`/admin/${league.leagueName}/${league.year}/divisions`}
												exact
											>
												Divisions
											</NavLink>
										</td>
										<td>
											<button
												className='buttonButton'
												id={key}
												onClick={(e) => showMoveToCurrentHandler(e)}
											>
												Move To Current
											</button>
										</td>
									</tr>
								)
							})}
						</tbody>
					</table>
				</div>
			)}
		</React.Fragment>
	)
}

export default AdminArchivedLeagueList
